import { OPTION_SET_ID_PREFIX } from "./optionTools";

// TODO: Replace 'settingsParam' with 'settingsOptionSet', will require migrating existing docs and their options/formulas
export const SETTINGS_OPTION_SET_SUFFIX = "settingsParam";

export function settingsOptionSetId(id: string, fieldName: string) {
  return `${OPTION_SET_ID_PREFIX}${id}_${fieldName}_${SETTINGS_OPTION_SET_SUFFIX}`;
}

export function isSettingsOptionSet(optionSetId: string) {
  return optionSetId.endsWith(SETTINGS_OPTION_SET_SUFFIX);
}

export function exteriorPaletteOptionSetId(settingsId: string) {
  return settingsOptionSetId(settingsId, "palettes");
}

export function interiorPaletteOptionSetId(settingsId: string) {
  return settingsOptionSetId(settingsId, "palettes");
}
